import { render, staticRenderFns } from "./RentalWifiRouter.vue?vue&type=template&id=4b4d473f&scoped=true&"
import script from "./RentalWifiRouter.vue?vue&type=script&lang=ts&"
export * from "./RentalWifiRouter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4d473f",
  null
  
)

export default component.exports